import { type Environment, type User } from '~/utils/types/user'

import {
  impersonate,
  validateSessionToken,
} from '../repositories/auth-repository'
import { getAuthenticatedHomePath } from '../utils/get-authenticated-home-path'

export interface ImpersonatedSession {
  homePath: string
  user: User
}

function parseEnvironment(env: string): Environment {
  if (env === 'testing' || env === 'demo' || env === 'platform') return env
  throw new Error(`Unsupported environment: ${env}`)
}

export async function impersonateUser(
  username: string,
  fallbackEnvironment: Environment,
): Promise<ImpersonatedSession> {
  const response = await impersonate({ username })
  const {
    access_token: accessToken,
    env,
    refresh_token: refreshToken,
    refresh_token_expires_at: refreshTokenExpiresAt,
    user: targetUser,
  } = response.data

  const { data: validatedUser } = await validateSessionToken(accessToken)

  const user: User = {
    daysToExpirePassword: targetUser.daysToExpirePassword,
    didExpire: targetUser.didExpire,
    dynamicLink: null,
    email: validatedUser.email,
    env: parseEnvironment(env ?? fallbackEnvironment),
    hub: validatedUser.application,
    id: validatedUser.userId,
    interactive_help:
      !!validatedUser.application &&
      !!validatedUser.application.interactiveHelp,
    name: validatedUser.name,
    organization: validatedUser.organization,
    permissions: validatedUser.permissions,
    phoneNumber: validatedUser.phoneNumber,
    refreshToken,
    refreshTokenExpiresAt,
    role: validatedUser.role,
    sessionExpired: false,
    sessionStart: Date.now(),
    sso: validatedUser.sso,
    stakeholder: validatedUser.stakeholder,
    token: accessToken,
    username: validatedUser.username,
    willExpire: targetUser.willExpire,
  }

  return { homePath: getAuthenticatedHomePath(user), user }
}
